import React from 'react'
import './styles.scss'
import { config } from './config'
import { perimeterNames, localesInterface } from 'components/main/types'
import { Hint } from 'components/Hint'
interface Props {
  locales: localesInterface
}

export const PerimeterLevels = ({ locales }: Props) => (
  <div className='perimetertablewrapper'>
    <table className='perimetertable'>
      <tbody>
        <tr>
          <td colSpan={2} className='tabletitle'>
            {locales.perimeter.title}
          </td>
        </tr>

        {Object.keys(config.colors.perimeter).map((c, i) => {
          return (
            <tr key={i}>
              <td className='swatch'>
                <img
                  src={require('images/icons_' +
                    config.colors.perimeter[c] +
                    '.svg')}
                />
              </td>
              <td>{locales.perimeter.steps[c as perimeterNames]}</td>
            </tr>
          )
        })}
        <tr>
          <td colSpan={2} className='np'>
            <Hint>
              <div className='hintcontent'>{locales.perimeter.hint}</div>
            </Hint>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
)
